import { criarFinalizador } from '@/uteis/action/tramite/finalizador'

export const getSolicitante = (dadosSessao) => {
  var solicitante = {
    solicitante: criarFinalizador(dadosSessao, true)
  }

  return solicitante
}
